import type {ErrorProcessor} from '../types'
import {LOAD_ERROR_MSG} from '../types'
import {getLoadErrorSrc, sendOnly} from '../utils'

const service = 'maps'

const apiMapsRE = new RegExp('//api-maps.yandex.(ru|com)')

const includesYaMapsUrl = (str?: string) =>
  str && (apiMapsRE.test(str) || str.includes('//yastatic.net/s3/front-maps-static'))

export const processMapsErrors: ErrorProcessor = (error, scope) => {
  if (error.message === LOAD_ERROR_MSG.SCRIPT && includesYaMapsUrl(getLoadErrorSrc(error))) {
    return sendOnly(0.1) && scope.updateError({service, level: Ya.Rum.ERROR_LEVEL.INFO})
  }

  if (includesYaMapsUrl(error.stack)) {
    return scope.updateError({service})
  }

  return error
}
